"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAuthoriserWithTrustedDevice = void 0;
const __1 = require("..");
const authoriser_1 = require("./authoriser");
class MbAuthoriserWithTrustedDevice extends authoriser_1.MbAuthoriser {
    constructor() {
        super(...arguments);
        this.state = {
            ...authoriser_1.DEFAULT_STATE,
            isTrustedDeviceRequired: false,
        };
    }
    updateState(state) {
        this.state = {
            ...this.state,
            ...state,
        };
        (0, __1.publishAuthoriserStateChangedEvent)(this.state);
    }
    noTrustedDevice() {
        this.updateState({ isTrustedDeviceRequired: true, isReadyToFinish: false });
    }
    reset() {
        super.reset();
        this.updateState({ isTrustedDeviceRequired: false });
    }
}
exports.MbAuthoriserWithTrustedDevice = MbAuthoriserWithTrustedDevice;
//# sourceMappingURL=authoriserTrustedDevice.js.map